import { c as _c } from "react/compiler-runtime";
import { classNames, Flex } from "@opensea/ui-kit";
import { fullBleedVariants } from "@/styles/utils/page-container";
import { ContentBlockModule } from "./components/ContentBlockModule";
import { FaqModule } from "./components/FaqModule";
import { NarrativeModule } from "./components/NarrativeModule";
import { TeamModule } from "./components/TeamModule";
const getComponent = module => {
  switch (module.__typename) {
    case "CollectionNarrativeModule":
      return <NarrativeModule module={module} />;
    case "CollectionContentBlockModule":
      return <ContentBlockModule module={module} />;
    case "CollectionTeamModule":
      return <TeamModule module={module} />;
    case "CollectionFAQModule":
      return <FaqModule module={module} />;
    default:
      return null;
  }
};
function OverviewSection(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(fullBleedVariants({
      width: "fullScreen"
    }), "group/overview-section overflow-hidden border-b border-b-border-1 last:border-none odd:bg-bg-app even:bg-bg-additional-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Flex className={t1}>{children}</Flex>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { getComponent, OverviewSection };